// This file was automatically generated from render.chartFeedItemNew.visitNoteShared.html.
// Please don't edit this file by hand.

goog.provide('el8.template.render.chartFeedItemNew.visitNoteShared');

goog.require('soy');
goog.require('soy.StringBuilder');
goog.require('el8.template.appshared.imo');
goog.require('el8.template.core');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.chartFeedItemNew.visitNoteShared.field = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.type == 'multilist' || opt_data.type == 'textmultilist') {
    el8.template.render.chartFeedItemNew.visitNoteShared.multilist(opt_data, output);
  } else if (opt_data.type == 'listeditor' || opt_data.type == 'textlisteditor' || opt_data.type == 'textlist') {
    el8.template.render.chartFeedItemNew.visitNoteShared.list(opt_data, output);
  } else if (opt_data.type == 'textarea') {
    el8.template.render.chartFeedItemNew.visitNoteShared.listTextarea(opt_data, output);
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.chartFeedItemNew.visitNoteShared.multilist = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.items.length > 0) {
    output.append('<span ', (opt_data.collapsible != false) ? 'class="collapsible-section"' : '', '>', (opt_data.label) ? (opt_data.isOneCol) ? '<p class="el8SmallHeading">' + soy.$$escapeHtml(opt_data.label) + '</p>' : '<label class="el8label el8FieldSaved">' + soy.$$escapeHtml(opt_data.label) + '</label>' : '');
    var itemList24978 = opt_data.items;
    var itemListLen24978 = itemList24978.length;
    for (var itemIndex24978 = 0; itemIndex24978 < itemListLen24978; itemIndex24978++) {
      var itemData24978 = itemList24978[itemIndex24978];
      output.append('<div class="fieldNoteSection"><label class="el8label el8FieldSaved">', soy.$$escapeHtml(itemIndex24978 + 1), ':</label><div class="el8FieldShortLabelPadding"><ol><li class="', (opt_data.isAssessment && ! opt_data.isEdit) ? 'el8ItemHover ' : '', 'el8StandardFontSize">', (opt_data.isAssessment && ! opt_data.isEdit) ? '<div class="el8ItemButtonContainer"><button type="button" class="el8button el8ItemButton addToNoteHpiTrigger" _fid="' + soy.$$escapeHtml(opt_data.feedItemId) + '" assessmentId="' + soy.$$escapeHtml(itemData24978.id) + '">Ref (HPI)</button></div>' : '', (itemData24978.textReplaced) ? '<span class="el8Strike el8Preserve">' + soy.$$escapeHtml(itemData24978.textReplaced) + '</span> ' : '', '<span', (itemData24978.itemId && ! opt_data.isEdit && ! opt_data.isImportedNote) ? ' class="item-details-trigger itemTrigger" data-id="' + soy.$$escapeHtml(itemData24978.itemId) + '"' : '', '>', (! itemData24978.isReplaced) ? (itemData24978.isEdit) ? ' <!-- Won\'t have safeText in edits right now --><span class="el8Edit el8Preserve">' + (el8.appservice && el8.appservice.highlighter ? el8.appservice.highlighter.highlightText(soy.$$escapeHtml(itemData24978.text)) : soy.$$escapeHtml(itemData24978.text)) + '</span>' : '<span class="el8Preserve">' + ((itemData24978.text) ? (el8.appservice && el8.appservice.highlighter ? el8.appservice.highlighter.highlightText(soy.$$escapeHtml(itemData24978.text)) : soy.$$escapeHtml(itemData24978.text)) : (itemData24978.safeText) ? (el8.appservice && el8.appservice.highlighter ? el8.appservice.highlighter.highlightText(itemData24978.safeText) : itemData24978.safeText) : '') + '</span>' : '  <!-- Won\'t have safeText in edits right now --><span class="el8Preserve el8Strike">' + (el8.appservice && el8.appservice.highlighter ? el8.appservice.highlighter.highlightText(soy.$$escapeHtml(itemData24978.text)) : soy.$$escapeHtml(itemData24978.text)) + '</span>', '</span></li>');
      if (opt_data.isAssessment && itemData24978.imos && itemData24978.imos.length) {
        output.append('<li class="collapsible-section el8StandardFontSize el8CodeSmaller">');
        el8.template.appshared.imo.imoList({imos: itemData24978.imos, icd10Only: true}, output);
        output.append('</li>');
      }
      output.append('</ol>');
      if (itemData24978.children) {
        el8.template.render.chartFeedItemNew.visitNoteShared.sublist({items: itemData24978.children}, output);
      }
      output.append('</div></div>');
    }
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.chartFeedItemNew.visitNoteShared.sublist = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.items.length > 0) {
    output.append('<span ', (opt_data.collapsible != false) ? 'class="collapsible-section"' : '', '><ol>');
    if (opt_data.items.length == 1) {
      el8.template.core.listItem(soy.$$augmentData(opt_data.items[0], {noBullet: true}), output);
    } else {
      var itemList25057 = opt_data.items;
      var itemListLen25057 = itemList25057.length;
      for (var itemIndex25057 = 0; itemIndex25057 < itemListLen25057; itemIndex25057++) {
        var itemData25057 = itemList25057[itemIndex25057];
        el8.template.core.listItem(itemData25057, output);
      }
    }
    output.append('</ol></span>');
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.chartFeedItemNew.visitNoteShared.list = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.items.length > 0) {
    output.append('<span ', (opt_data.collapsible != false) ? 'class="collapsible-section"' : '', '><div class="fieldNoteSection">', (opt_data.label) ? '<label class="el8label el8FieldSaved">' + soy.$$escapeHtml(opt_data.label) + '</label>' : '', '<ol class="el8FieldShortLabelPadding">');
    if (opt_data.items.length == 1) {
      el8.template.core.listItem(soy.$$augmentData(opt_data.items[0], {triggerClass: opt_data.items[0].itemId && ! opt_data.isEdit && ! opt_data.isImportedNote ? 'item-details-trigger itemTrigger' : null, noBullet: true}), output);
    } else {
      var itemList25081 = opt_data.items;
      var itemListLen25081 = itemList25081.length;
      for (var itemIndex25081 = 0; itemIndex25081 < itemListLen25081; itemIndex25081++) {
        var itemData25081 = itemList25081[itemIndex25081];
        el8.template.core.listItem(soy.$$augmentData(itemData25081, {triggerClass: itemData25081.itemId && ! opt_data.isEdit && ! opt_data.isImportedNote ? 'item-details-trigger itemTrigger' : null}), output);
      }
    }
    output.append('</ol></div></span>');
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.chartFeedItemNew.visitNoteShared.listTextarea = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.items.length > 0) {
    output.append('<span ', (opt_data.collapsible != false) ? 'class="collapsible-section"' : '', '><div class="fieldNoteSection">', (opt_data.label) ? (opt_data.isOneCol) ? '<p class="el8SmallHeading">' + soy.$$escapeHtml(opt_data.label) + '</p>' : '<label class="el8label el8FieldSaved">' + soy.$$escapeHtml(opt_data.label) + '</label>' : '');
    var itemList25105 = opt_data.items;
    var itemListLen25105 = itemList25105.length;
    for (var itemIndex25105 = 0; itemIndex25105 < itemListLen25105; itemIndex25105++) {
      var itemData25105 = itemList25105[itemIndex25105];
      el8.template.render.chartFeedItemNew.visitNoteShared.textareaItem({item: itemData25105}, output);
    }
    output.append('</div></span>');
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.chartFeedItemNew.visitNoteShared.textareaItem = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<p class="el8Wrap el8Preserve">', (opt_data.item.textReplaced) ? '<span class="el8Strike">' + soy.$$escapeHtml(opt_data.item.textReplaced) + '</span> ' : '', '<span class="', (opt_data.item.isReplaced) ? 'el8Strike' : (opt_data.item.isEdit) ? 'el8Edit' : '', '">', (opt_data.item.text) ? (el8.appservice && el8.appservice.highlighter ? el8.appservice.highlighter.highlightText(soy.$$escapeHtml(opt_data.item.text)) : soy.$$escapeHtml(opt_data.item.text)) : (opt_data.item.safeText) ? (el8.appservice && el8.appservice.highlighter ? el8.appservice.highlighter.highlightText(opt_data.item.safeText) : opt_data.item.safeText) : (el8.appservice && el8.appservice.highlighter ? el8.appservice.highlighter.highlightText(soy.$$escapeHtml(opt_data.item)) : soy.$$escapeHtml(opt_data.item)), '</span></p>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.chartFeedItemNew.visitNoteShared.checklist = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.items.length > 0 || opt_data.details.length > 0) {
    output.append('<div class="collapsible-section"><div class="fieldNoteSection">', (opt_data.label) ? (opt_data.isOneCol) ? '<p class="el8SmallHeading">' + soy.$$escapeHtml(opt_data.label) + '</p>' : '<label class="el8label el8FieldSaved">' + soy.$$escapeHtml(opt_data.label) + '</label>' : '');
    if (opt_data.type == 'textarea') {
      var itemList25153 = opt_data.items;
      var itemListLen25153 = itemList25153.length;
      for (var itemIndex25153 = 0; itemIndex25153 < itemListLen25153; itemIndex25153++) {
        var itemData25153 = itemList25153[itemIndex25153];
        el8.template.render.chartFeedItemNew.visitNoteShared.textareaItem({item: itemData25153}, output);
      }
      el8.template.render.chartFeedItemNew.visitNoteShared.checklistDetails(opt_data, output);
    } else {
      output.append((opt_data.isOneCol) ? '<div class="el8Wrap">' : '<div class="el8FieldShortLabelPadding">');
      el8.template.render.chartFeedItemNew.visitNoteShared.sublist(soy.$$augmentData(opt_data, {collapsible: false}), output);
      el8.template.render.chartFeedItemNew.visitNoteShared.checklistDetails(opt_data, output);
      output.append('</div>');
    }
    output.append('</div></div>');
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.chartFeedItemNew.visitNoteShared.checklistDetails = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.details.length > 0) {
    output.append('<ol>');
    var detailList25173 = opt_data.details;
    var detailListLen25173 = detailList25173.length;
    for (var detailIndex25173 = 0; detailIndex25173 < detailListLen25173; detailIndex25173++) {
      var detailData25173 = detailList25173[detailIndex25173];
      output.append('<li class="el8NoBullet"><span class="italic">', soy.$$escapeHtml(detailData25173.choice), ':</span> ', (detailData25173.valueReplaced) ? '<span class="el8Strike">' + soy.$$escapeHtml(detailData25173.valueReplaced) + '</span> ' : '', (detailData25173.value) ? '<span class="el8Preserve' + ((detailData25173.isEdit) ? ' el8Edit' : '') + '">' + (el8.appservice && el8.appservice.highlighter ? el8.appservice.highlighter.highlightText(soy.$$escapeHtml(detailData25173.value)) : soy.$$escapeHtml(detailData25173.value)) + '</span> ' : '', '</li>');
    }
    output.append('</ol>');
  }
  if (!opt_sb) return output.toString();
};
